import React, { useEffect, useState } from "react"
import { getFormValues, initialize } from "redux-form"
import { Container, Row, Col, Card, CardBody } from "reactstrap"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import PageMetaTags from "components/PageMetaTags"
import PopupPreview from "components/PhonePreview/PopupPreview"
import Form from "containers/Popup/Form"
import { connect } from "react-redux"
import { getPopupSetup, addPopupSetup } from "store/actions"
import { withRouter, Link } from "react-router-dom"
import { LOCAL_STORAGE_TAGS, FORM_NAMES } from "constants/index"
import { getFileBlob } from "utils"

const PAGE_TITLE = "Pop Up Ad Module"

const Popup = props => {
  const handleSubmitPopupForm = values => {
    let body = {
      ...values,
      status: values?.status ? 1 : 0,
      delete_image: values?.delete_image || 0,
      is_advertisement: values.is_advertisement ? 1 : 0,
      vendor_id: localStorage.getItem(LOCAL_STORAGE_TAGS.VENDOR_ID_TAG),
      image: values?.image_url?.editedImage
        ? getFileBlob(values?.image_url?.editedImage)
        : null,
      image_url: null,
    }
    props.addPopupSetup(body)
  }

  useEffect(() => {
    props.getPopupSetup()
  }, [])

  useEffect(() => {
    if (props?.popupSetup) {
      props.initializeForm({
        button_text: props?.popupSetup?.button_text,
        button_url: props?.popupSetup?.button_url,
        text: props?.popupSetup?.text,
        title: props?.popupSetup?.title,
        vendor_id: props?.popupSetup?.vendor_id,
        image_url: { editedImage: props.popupSetup?.image_url },
        visibility_limit: props.popupSetup.visibility_limit || 0,
        status: props.popupSetup.status || 0,
        is_advertisement: props.popupSetup.is_advertisement === 1,
      })
    }
  }, [props.popupSetup])

  const [breadcrumbItems, setBreadcrumbItems] = useState([])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title={PAGE_TITLE} />
        <Container fluid>
          <BreadcrumbTitle
            title={PAGE_TITLE}
            breadcrumbItems={breadcrumbItems}
          />
          <Card>
            <CardBody>
              <Row>
                <Col xl="8">
                  <Form
                    onSubmit={handleSubmitPopupForm}
                    initialValues={
                      props.popupSetup && {
                        ...props.popupSetup,
                        image_url: { editedImage: props.popupSetup?.image_url },
                        visibility_limit:
                          props.popupSetup.visibility_limit || 0,
                        status: props.popupSetup.status || 0,
                        is_advertisement:
                          props.popupSetup.is_advertisement === 1,
                      }
                    }
                    loading={props.saveLogin}
                    setBreadcrumbItems={setBreadcrumbItems}
                  />
                </Col>
                <Col xl={4} className="d-none d-xl-block">
                  <PopupPreview
                    previewData={
                      {
                        ...props.popupFormValues,
                        image_url:
                          props.popupFormValues?.image_url?.editedImage,
                      } || {}
                    }
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}
let popupFormValues = getFormValues(FORM_NAMES.POPUP)
const mapStateToProps = state => ({
  popupSetup: state.popup.popupSetup,
  saveLogin: state.popup.saveLogin,
  popupFormValues: popupFormValues(state),
})

const mapDispatchToProps = dispatch => ({
  getPopupSetup: values => dispatch(getPopupSetup(values)),
  addPopupSetup: values => dispatch(addPopupSetup(values)),
  initializeForm: values => dispatch(initialize(FORM_NAMES.POPUP, values)),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Popup))
